import { useCallback } from 'react';
import type { AnalyticsOverviewDashboard } from '@/types/analytics/dashboard';
import { getOverviewDashboard } from '@/services/analytics/dashboard.service';
import { useAnalyticsSection } from './use-analytics-section';

const EMPTY: AnalyticsOverviewDashboard = {
  visitsToday: 0,
  visitsWeek: 0,
  visitsMonth: 0,
  pageviews: 0,
  activeUsers: 0,
  sessions: 0,
  avgSessionDurationLabel: '—',
  bounceRateLabel: '—',
  interactionRateLabel: '—',
  zeroResultRateLabel: '—',
  visitsTrend: null,
  interactionTrend: null,
  durationTrend: null,
  zeroResultTrend: null,
  visitsSeries: [],
  channels: [],
  topQueries: [],
  zeroResults: [],
  userFunnel: [],
  ga4Connected: false,
};

export function useAnalyticsOverview() {
  const loader = useCallback(() => getOverviewDashboard(), []);
  return useAnalyticsSection(loader, EMPTY);
}
